module.exports = __webpack_public_path__ + "static/media/16․05.ecb7c507.webp";